import React from "react";
import { connect } from "react-redux";
import { CustomerEditContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { Displays, Forms } from "components";

class CustomerEditContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await portalService.GET_CUSTOMER_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleClickBack = (e) => {
    this.props.router.navigate(-1);
  };

  handleSubmit = async (values) => {
    let params = {
      ...values,
    };
    if (values.province) {
      params.province = values.province.name_th;
      params.province_en = values.province.name_en;
      params.province_code = values.province.initialValues;
    }
    let res = await portalService.PUT_CUSTOMER_UPDATE(
      this.props.router.params.id,
      params
    );
    if (res && res.status === 200) {
      this.props.router.navigate(-1);
    }
  };

  render() {
    const { isLoading, isBgLoading, data } = this.state;

    return (
      <CustomerEditContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <div className="block_section mb_1">
            <Forms.CustomerEditForm
              initialValues={data}
              onSubmit={this.handleSubmit}
              onBack={this.handleClickBack}
            />
          </div>
        )}
      </CustomerEditContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomerEditContainer));
